import { WeezAccessLogo, WeezCrewLogo, WeezPayLogo, WeezTargetLogo, WeezTicketLogo } from '../images';

export const Products = {
    ticket: {
        name: 'WeezTicket',
        // eslint-disable-next-line react/react-in-jsx-scope
        logo: <img src={WeezTicketLogo} alt={''} style={{ height: '100%' }} loading="lazy" />
    },
    target: {
        name: 'WeezTarget',
        // eslint-disable-next-line react/react-in-jsx-scope
        logo: <img src={WeezTargetLogo} alt={''} style={{ height: '100%' }} loading="lazy" />
    },
    pay: {
        name: 'WeezPay',
        // eslint-disable-next-line react/react-in-jsx-scope
        logo: <img src={WeezPayLogo} alt={''} style={{ height: '100%' }} loading="lazy" />
    },
    access: {
        name: 'WeezAccess',
        // eslint-disable-next-line react/react-in-jsx-scope
        logo: <img src={WeezAccessLogo} alt={''} style={{ height: '100%' }} loading="lazy" />
    },
    crew: {
        name: 'WeezCrew',
        // eslint-disable-next-line react/react-in-jsx-scope
        logo: <img src={WeezCrewLogo} alt={''} style={{ height: '100%' }} loading="lazy" />
    }
};

export const ProductOptions = Object.entries(Products).map(([key, value]) => ({
    key,
    text: (
        // eslint-disable-next-line react/react-in-jsx-scope
        <div style={{ height: '20px', display: 'flex', alignItems: 'center', gap: '8px' }}>
            {value.logo}
            {/* eslint-disable-next-line react/react-in-jsx-scope */}
            <span>{value.name}</span>
        </div>
    ),
    name: key,
    value: key
}));
